import React, { useState, useMemo, useEffect, useContext } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import MUIDataTable from "components/mui-datatable";
import TableAllData from "components/Content/CustomTable/TableAllData";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import AximTooltip from "components/AximTooltip";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Slide,
    TextField,
    Typography,
    InputAdornment,
    IconButton,
    Checkbox
} from "@mui/material";

import ButtonStyle from "components/Button/ButtonStyle.module.css";
import { Box } from "@mui/material";
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import LoaderAnimation from "pages/LoaderAnimation";
import { Utils } from "common/Utils";
import _ from 'lodash';
import moment from "moment";
import CurrencyFormatter from "components/Formatter/CurrencyFormatter";
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
})
export default function AddContractUserModal(props) {

    const validationUserSchema = Yup.object().shape({
        firstName: Yup.string().required('First Name is required')
            .max(50, 'First Name must not exceed 50 characters'),
        lastName: Yup.string().required('Last Name is required')
            .max(50, 'Last Name must not exceed 50 characters'),
        email: Yup.string().required('Email is required')
            .max(200, 'Email must not exceed 200 characters')
    })

    const {
        register: registerUser,
        control: controlUser,
        handleSubmit: handleSubmitUser,
        reset: resetUser,
        setValue: setValueUser,
        formState: { errors: userErrors }
    } = useForm({
        resolver: yupResolver(validationUserSchema)
    })


    const [checkingData, setCheckingData] = useState(true)
    const [openModal, setOpen] = useState(false)
    const [openContractListModal, setOpenContractListModal] = useState(false)

    const [contractUserError, setContractUserError] = useState('')
    const newContractUser = {
        "contractUserID": Utils.emptyGuid(),
        "userID": Utils.emptyGuid(),
        "firstName": "",
        "lastName": "",
        "email": ""
    };
    const [contractUser, setContractUser] = React.useState(newContractUser)
    const [userContractList, setUserContractList] = React.useState([])
    const [savingUserData, setSavingUserData] = React.useState(false)

    const resetContractListCheck = (currentList) => {
        let cList = [];
        const contractList = JSON.parse(localStorage.getItem(`contractList`)|| "[]")
        console.log(contractList, 'available list')
        console.log(currentList, 'current list')
        for (const d of contractList) {
            cList.push({
                contractID: d.contractID,
                contractName: d.contractName,
                contractCode: d.contractCode,
                checked: (currentList.filter(c => c.contractID == d.contractID).length>0)
            })
        }
        setUserContractList(cList)
    }

    const onSubmitUser = data => {
        handleSaveContractUser()
    };

    const handleClose = () => {
        setOpen(false)
        //setAnchorEl(null)
    };
    
    const handleCloseContractList = () => {
        setOpenContractListModal(false)
    };

    const handleEditUser = (contractUser) => {
        console.log(contractUser, 'contractUser')
        setContractUser(contractUser)
        // resetUser(contractUser)
        //fetchUserContracts(contractUser.userId)
    }

    const handleUserChange = (propName, propValue) => {
        let obj = { ...contractUser }
        obj[propName] = propValue
        setContractUser(obj)
        console.log(propName)
        console.log(propValue)
        setValueUser(propName, propValue, { shouldValidate: true })
    };

    const handleSaveContractUser = () => {
        setContractUserError('saving...')
        console.log(`saving user to company ${props.companyId}`)
        //setSavingUserData(true)
        //let companyId = localStorage.getItem(`selectedCompanyId`)
        apiPost(apiUrls.postContractUser(props.companyId), contractUser)
            .then((response) => {
                props.handleCloseUser()
                //fetchContractUsers()
                props.refreshUsers()
            })
            .catch(function (error) {
                console.log(error)
                setContractUserError(error.response.data)
            })
            .then(function () {
                setSavingUserData(false)
            })

    };

    // const handleAssignUserToContract = () => {
    //     console.log('handleAssignUserToContract')
    //     console.log(contractUser, 'contract user')
    //     let companyId = localStorage.getItem(`selectedCompanyId`)
    //     let contracts = userContractList.filter(ct => ct.checked).map(c => c.contractID)

    //     console.log(contracts, 'contract list')

    //     apiPost(apiUrls.postUserToContracts(companyId,contractUser.userId), contracts)
    //         .then((response) => {
    //             console.log(response)
    //             setOpenContractListModal(false)
    //             //fetchContractUsers()
    //         })
    //         .catch(function (error) {
    //             console.log(error)
    //             //setContractUserError(error.response.data)
    //         })
    //         .then(function () {
    //             setSavingUserData(false)
    //         })

    // }


    let columns = [
        {
            Header: "Action",
            accessor: (cell) => (
                <IconButton color="primary" aria-label="Edit" component="span"
                    onClick={() => handleEditUser(cell)} >
                    <EditOutlinedIcon />
                </IconButton>),
            disableFilters: true,
        },
        {
            Header: "First Name",
            accessor: "firstName",
        },
        {
            Header: "Last Name",
            accessor: "lastName",
        },
        {
            Header: "Login Name",
            accessor: "userName",
        }
    ];

    const contractColumns = [
        {
            Header: "Action",
            accessor: (cell) => (<>
                <Checkbox
                    checked={cell.checked}
                    onClick={() => {
                        let newList = userContractList.map(c =>
                            c.contractID === cell.contractID
                                ? { ...c, checked: !cell.checked }
                                : c
                        )
                        setUserContractList(newList)
                    }}
                ></Checkbox></>),
            disableFilters: true,
        },
        {
            Header: "Contract Name",
            accessor: "contractName",
        }
    ];
    return (
        <>
            {/* Add Contract MODAL */}
            <Dialog
                open={true}
                TransitionComponent={Transition}
                keepMounted
                onClose={props.handleCloseUser}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                className={TableStyle.fileTypeModalWrapper}
                fullWidth
            >
                <DialogTitle id="alert-dialog-slide-title">
                    {(contractUser.userID == Utils.emptyGuid() ? "Add Contract User" : "Edit Contract User")}
                </DialogTitle>
                <DialogContent>
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '25ch' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <div>
                            <TextField
                                {...registerUser('firstName')}
                                label="First Name"
                                InputLabelProps={{ shrink: true }}
                                required
                                defaultValue={contractUser.firstName}
                                id="firstName"
                                name="firstName"
                                value={contractUser.firstName}
                                variant="standard"
                                onChange={(e) => handleUserChange('firstName', e.target.value)}
                                error={userErrors.firstName ? true : false}
                                helperText={userErrors.firstName?.message}
                            />
                            <TextField
                                {...registerUser('lastName')}
                                label="Last Name"
                                InputLabelProps={{ shrink: true }}
                                required
                                defaultValue={contractUser.lastName}
                                id="lastName"
                                name="lastName"
                                value={contractUser.lastName}
                                variant="standard"
                                onChange={(e) => handleUserChange('lastName', e.target.value)}
                                error={userErrors.lastName ? true : false}
                                helperText={userErrors.lastName?.message}
                            />
                            <TextField
                                label="Login Name"
                                InputLabelProps={{ shrink: true }}
                                disabled
                                defaultValue={contractUser.loginName}
                                id="loginName"
                                name="loginName"
                                value={contractUser.loginName}
                                variant="standard"
                            />

                        </div>
                        <div>
                            <TextField
                                {...registerUser('email')}
                                label="Email"
                                InputLabelProps={{ shrink: true }}
                                required
                                defaultValue={contractUser.email}
                                id="email"
                                name="email"
                                value={contractUser.email}
                                variant="standard"
                                onChange={(e) => handleUserChange('email', e.target.value)}
                                error={userErrors.email ? true : false}
                                helperText={userErrors.email?.message}
                            />
                        </div>
                        <div>
                            {contractUserError}
                        </div>
                    </Box>
                </DialogContent>
                <DialogActions className={ButtonStyle.buttonWrapper}>
                    {(<Button
                        variant="outlined"
                        onClick={handleSubmitUser(onSubmitUser)}
                        disabled={savingUserData}
                    >
                        {(savingUserData ? "Saving" : "Save")}
                    </Button>)}
                    
                    <Button onClick={props.handleCloseUser} className={ButtonStyle.CcancelBtn}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    )
}